import { formatNumber } from './number';

const formatDistance = (distanceInMeters, decimals = 2) => {
  const distanceInKm = (distanceInMeters / 1000).toFixed(decimals);
  return `${formatNumber(parseFloat(distanceInKm))} km`;
};
export { formatDistance };
